
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { languageMixin } from "@/mixins/languageMixin";
import MainHeader from "@/components/main-header.vue";
import { GetKnowledgeList } from "@/request/knowledge";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends mixins(listMixin, languageMixin) {
  private data: any = [];
  private tabs: any = [
    {
      label: "症状体征",
      value: "症状体征",
    },
    {
      label: "中医疾病",
      value: "中医疾病",
    },
    {
      label: "中医证型",
      value: "中医证型",
    },
    {
      label: "中药方剂",
      value: "方剂",
    },
    {
      label: "中药饮片",
      value: "中药饮片",
    },
    {
      label: "中医病因",
      value: "中医病因",
    },
    {
      label: "中医病机",
      value: "中医病机",
    },
    {
      label: "中医治则",
      value: "中医治则",
    },
    {
      label: "中医治法",
      value: "中医治法",
    },
    {
      label: "临床路径",
      value: "临床路径",
    },
  ];
  private cTab = {};
  private changeTab(item: any) {
    this.filters.cTab = item;
    this.filters.search = "";
    this.search();
  }
  private goDetail(item: any) {
    this.$router.push({
      path: "/main/knowledge/detail",
      query: {
        id: item.id,
      },
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("knowledgeFilter", JSON.stringify(this.filters));
    const params: any = {
      params: {
        table_name: this.filters.cTab.value,
        search: this.filters.search,
        order_field: "更新时间",
        order_value: 0,
        current_page: this.filters.current_page,
        page_num: this.filters.page_count,
      },
    };
    GetKnowledgeList(this, params, loading).then((res: any) => {
      loading.close();
      this.data = res.data;
      this.filters.total_count = res.total_count;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    this.filters.cTab = {
      label: "症状体征",
      value: "症状体征",
    };
    if (localStorage.getItem("knowledgeFilter")) {
      this.filters = JSON.parse(localStorage.getItem("knowledgeFilter") as any);
    }
    this.getList();
  }
}
